"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowCUpIcon = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var Icon_1 = require("../../internal/Icon");
var ArrowCUpIcon16Light_1 = require("./ArrowCUpIcon16Light");
var ArrowCUpIcon16Regular_1 = require("./ArrowCUpIcon16Regular");
var ArrowCUpIcon16Solid_1 = require("./ArrowCUpIcon16Solid");
var ArrowCUpIcon20Light_1 = require("./ArrowCUpIcon20Light");
var ArrowCUpIcon20Regular_1 = require("./ArrowCUpIcon20Regular");
var ArrowCUpIcon20Solid_1 = require("./ArrowCUpIcon20Solid");
var ArrowCUpIcon24Regular_1 = require("./ArrowCUpIcon24Regular");
var ArrowCUpIcon24Solid_1 = require("./ArrowCUpIcon24Solid");
var ArrowCUpIcon32Regular_1 = require("./ArrowCUpIcon32Regular");
var ArrowCUpIcon64Regular_1 = require("./ArrowCUpIcon64Regular");
var sizes = {
    16: {
        light: ArrowCUpIcon16Light_1.ArrowCUpIcon16Light,
        regular: ArrowCUpIcon16Regular_1.ArrowCUpIcon16Regular,
        solid: ArrowCUpIcon16Solid_1.ArrowCUpIcon16Solid,
    },
    20: {
        light: ArrowCUpIcon20Light_1.ArrowCUpIcon20Light,
        regular: ArrowCUpIcon20Regular_1.ArrowCUpIcon20Regular,
        solid: ArrowCUpIcon20Solid_1.ArrowCUpIcon20Solid,
    },
    24: {
        regular: ArrowCUpIcon24Regular_1.ArrowCUpIcon24Regular,
        solid: ArrowCUpIcon24Solid_1.ArrowCUpIcon24Solid,
    },
    32: {
        regular: ArrowCUpIcon32Regular_1.ArrowCUpIcon32Regular,
    },
    64: {
        regular: ArrowCUpIcon64Regular_1.ArrowCUpIcon64Regular,
    },
};
exports.ArrowCUpIcon = forwardRef_1.forwardRef('ArrowCUpIcon', function (props, ref) {
    return react_1.default.createElement(Icon_1.Icon, tslib_1.__assign({ ref: ref }, props, { sizes: sizes }));
});
